import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import * as ScheduleApi from './api';
import * as ProjectActionType from 'Projects/constants';
import * as NotifyActionType from 'Notification/constants';

export function* getSettingsAsync(action) {
  const result = yield call(ScheduleApi.getMaintenanceSettings, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_MAINTENANCE_SETTINGS_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  }
  else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data
    });
  }
}

export function* updateSettingsAsync(action) {
  const result = yield call(ScheduleApi.putMaintenanceSettings, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'})
    ];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* getTimeZoneListAsync(action) {
  const result = yield call(ScheduleApi.getTimeZoneList);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_MAINTENANCE_SETTINGS_TIMEZONE_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  }
  else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data
    });
  }
}

export function* createGeneralTaskAsync(action) {
  const result = yield call(ScheduleApi.postGeneralTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* updateGeneralTaskAsync(action) {
  const result = yield call(ScheduleApi.putGeneralTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* createSpecificTaskAsync(action) {
  const result = yield call(ScheduleApi.postSpecificTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* updateSpecificTaskAsync(action) {
  const result = yield call(ScheduleApi.putSpecificTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* getGeneralTaskAsync(action) {
  const result = yield call(ScheduleApi.getGeneralTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_MAINTENANCE_GENERAL_TASK_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* getSpecificTaskAsync(action) {
  const result = yield call(ScheduleApi.getSpecificTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_MAINTENANCE_SPECIFIC_TASK_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* getLotListAsync(action) {
  const result = yield call(ScheduleApi.getLotList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_MAINTENANCE_LOT_LIST_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* getTaskListAsync(action) {
  const result = yield call(ScheduleApi.getTaskList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_MAINTENANCE_TASK_LIST_SUCCESS,
        data: result.data
      })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* getTaskReminderListAsync(action) {
  const result = yield call(ScheduleApi.getTaskReminderList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_MAINTENANCE_TASK_REMINDER_LIST_SUCCESS,
        data: result.data
      })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}
export function* removeTaskAsync(action) {
  const result = yield call(ScheduleApi.removeTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.DELETE_MAINTENANCE_TASK_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* getSuggestedGeneralTaskAsync(action) {
  const result = yield call(ScheduleApi.getSuggestedGeneralTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_MAINTENANCE_SUGGESTED_GENERAL_TASK_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* getSuggestedSpecificTaskAsync(action) {
  const result = yield call(ScheduleApi.getSuggestedSpecificTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_MAINTENANCE_SUGGESTED_SPECIFIC_TASK_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export function* postSuggestedGeneralTaskAsync(action) {
  const result = yield call(ScheduleApi.postSuggestedGeneralTask, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.ADD_MAINTENANCE_SUGGESTED_GENERAL_TASK_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { error: result.data, data: action.params.data }
    });
  }
}

export default function* MaintenanceSaga() {
  yield all([
    takeLatest(ProjectActionType.GET_MAINTENANCE_SETTINGS_ASYNC, getSettingsAsync),
    takeLatest(ProjectActionType.UPDATE_MAINTENANCE_SETTINGS_ASYNC, updateSettingsAsync),
    takeLatest(ProjectActionType.GET_MAINTENANCE_SETTINGS_TIMEZONE_ASYNC, getTimeZoneListAsync),
    takeLatest(ProjectActionType.CREATE_MAINTENANCE_GENERAL_TASK_ASYNC, createGeneralTaskAsync),
    takeLatest(ProjectActionType.UPDATE_MAINTENANCE_GENERAL_TASK_ASYNC, updateGeneralTaskAsync),
    takeLatest(ProjectActionType.UPDATE_MAINTENANCE_SPECIFIC_TASK_ASYNC, updateSpecificTaskAsync),
    takeLatest(ProjectActionType.CREATE_MAINTENANCE_SPECIFIC_TASK_ASYNC, createSpecificTaskAsync),
    takeLatest(ProjectActionType.GET_MAINTENANCE_GENERAL_TASK_ASYNC, getGeneralTaskAsync),
    takeLatest(ProjectActionType.GET_MAINTENANCE_SPECIFIC_TASK_ASYNC, getSpecificTaskAsync),
    takeLatest(ProjectActionType.GET_MAINTENANCE_LOT_LIST_ASYNC, getLotListAsync),
    takeLatest(ProjectActionType.GET_MAINTENANCE_TASK_LIST_ASYNC, getTaskListAsync),
    takeLatest(ProjectActionType.DELETE_MAINTENANCE_TASK_ASYNC, removeTaskAsync),
    takeLatest(ProjectActionType.GET_MAINTENANCE_SUGGESTED_GENERAL_TASK_ASYNC, getSuggestedGeneralTaskAsync),
    takeLatest(ProjectActionType.GET_MAINTENANCE_SUGGESTED_SPECIFIC_TASK_ASYNC, getSuggestedSpecificTaskAsync),
    takeLatest(ProjectActionType.ADD_MAINTENANCE_SUGGESTED_GENERAL_TASK_ASYNC, postSuggestedGeneralTaskAsync),
    takeLatest(ProjectActionType.GET_MAINTENANCE_TASK_REMINDER_LIST_ASYNC, getTaskReminderListAsync)
  ]);
}




// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/saga.js